// Modül 8 - Grup Mülakatı Simülasyonu - İnteraktif İçerikler

const cabinCrewContentsM8Interactive = {
  // ==================== ÜNİTE 1: PROBLEM ÇÖZME ====================
  'CM-M8-U1-L1': {
    lesson_id: 'CM-M8-U1-L1',
    title: 'Tarafsız Kalma',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '⚖️ Tarafsızlık = Profesyonellik',
      intro: 'Grup içi anlaşmazlıkta tarafsız kal!',
      facts: [
        { icon: '👂', title: 'Dinle', text: 'Her iki tarafı da dinle' },
        { icon: '⚖️', title: 'Tarafsız Ol', text: 'Taraf tutma' },
        { icon: '🤝', title: 'Köprü Kur', text: 'Ortak noktayı bul' },
        { icon: '🎯', title: 'Çözüm Odaklı', text: 'Problem değil, çözüm' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İki aday tartışıyorsa?',
        options: [
          { text: 'Birinin tarafını tut', isCorrect: false, feedback: '❌ Taraf tutma!' },
          { text: 'Arabulucu ol, ortak nokta bul', isCorrect: true, feedback: '✅ Profesyonel liderlik!' },
          { text: 'Görmezden gel', isCorrect: false, feedback: '❌ Fırsatı kaçırırsın!' }
        ]
      }
    }
  },

  'CM-M8-U1-L2': {
    lesson_id: 'CM-M8-U1-L2',
    title: 'Ortak Çözüm',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🤝 Kazan-Kazan Çözüm',
      intro: 'İyi çözüm herkesin kazanıdır',
      steps: [
        { level: 1, title: '🔍 ANLA', desc: 'Her fikrin güçlü yanını bul' },
        { level: 2, title: '🧩 BİRLEŞTİR', desc: 'Fikirleri birleştir' },
        { level: 3, title: '🎯 UZLAŞ', desc: 'Herkesi dahil et' },
        { level: 4, title: '✅ SONUCU PAYLAŞ', desc: 'Takım başarısı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi çözüm yaklaşımı?',
        options: [
          { text: 'Kendi fikrin kazansın', isCorrect: false, feedback: '❌ Bencil!' },
          { text: 'Tüm fikirlerin iyi yanlarını birleştir', isCorrect: true, feedback: '✅ Takım ruhu!' },
          { text: 'Oylama yap', isCorrect: false, feedback: '❌ Bölücü olabilir!' }
        ]
      }
    }
  },

  'CM-M8-U1-L3': {
    lesson_id: 'CM-M8-U1-L3',
    title: 'Simülasyon: Anlaşmazlık',
    type: 'scenario',
    duration: 5,
    xp: 50,
    scenario: {
      question: '👥 SİMÜLASYON: Fikir Çatışması',
      context: 'Grup aktivitesinde iki aday farklı çözümler savunuyor ve tartışma kızışıyor. Siz ne yaparsınız?',
      options: [
        { id: 'A', text: 'Güçlü görünen tarafı destekle', isCorrect: false },
        { id: 'B', text: '"Her iki fikrin de güçlü yanları var, birleştirelim"', isCorrect: true },
        { id: 'C', text: 'Sessiz kal, bitsin', isCorrect: false },
        { id: 'D', text: 'Üçüncü bir fikir sun', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 MÜKEMMEL ARABULUCULUK! Bu liderlik ve takım ruhu gösterir!',
        wrong: '❌ Taraf tutma veya pasif kalma riskli!'
      },
      explanation: 'Arabuluculuk = En değerli liderlik becerisi. Fikirleri birleştirmek herkesi kazançlı çıkarır.'
    }
  },

  // ==================== ÜNİTE 2: SUNUM YAPMA ====================
  'CM-M8-U2-L1': {
    lesson_id: 'CM-M8-U2-L1',
    title: 'Özgüvenli Duruş',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🎤 Sunum Sırasında Beden Dili',
      intro: 'Grup önünde konuşurken:',
      facts: [
        { icon: '🧑‍🤝‍🧑', title: 'Dik Dur', text: 'Omuzlar geri, baş dik' },
        { icon: '👀', title: 'Göz Tara', text: 'Herkesle göz teması' },
        { icon: '👋', title: 'Açık Eller', text: 'Doğal jestler kullan' },
        { icon: '🙂', title: 'Gülümse', text: 'Rahat ve sıcak' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Sunum sırasında göz teması?',
        options: [
          { text: 'Sadece bir kişiye bak', isCorrect: false, feedback: '❌ Diğerlerini dışla!' },
          { text: 'Herkese sırayla bak', isCorrect: true, feedback: '✅ Herkesi dahil et!' },
          { text: 'Yere bak', isCorrect: false, feedback: '❌ Güvensiz!' }
        ]
      }
    }
  },

  'CM-M8-U2-L2': {
    lesson_id: 'CM-M8-U2-L2',
    title: 'Etkili Anlatım',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🗣️ Net ve Kısa Anlatım',
      intro: 'Sunum yapılışı için altın kurallar:',
      categories: [
        { icon: '✅', title: 'Yap', examples: 'Kısa ve özlü ol', desc: '30-60 saniye' },
        { icon: '✅', title: 'Yap', examples: 'Ana fikir + Örnek', desc: 'Somut ol' },
        { icon: '❌', title: 'Yapma', examples: 'Uzun uzun açıklama', desc: 'Sıkıcı' },
        { icon: '❌', title: 'Yapma', examples: 'Eh, şey, hani...', desc: 'Doldurma sözcükler' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İdeal sunum süresi?',
        options: [
          { text: '10 saniye', isCorrect: false, feedback: '❌ Çok kısa!' },
          { text: '30-60 saniye', isCorrect: true, feedback: '✅ Özlü ve etkili!' },
          { text: '3+ dakika', isCorrect: false, feedback: '❌ Çok uzun!' }
        ]
      }
    }
  },

  'CM-M8-U2-L3': {
    lesson_id: 'CM-M8-U2-L3',
    title: 'Simülasyon: Sunum',
    type: 'scenario',
    duration: 5,
    xp: 50,
    scenario: {
      question: '🎤 SİMÜLASYON: Grup Sunumu',
      context: 'Grup adına çözümü sunman istendi. Nasıl başlarsın?',
      options: [
        { id: 'A', text: '"Biz şöyle düşündük..." diye uzun anlat', isCorrect: false },
        { id: 'B', text: '"Grubumuz 3 ana nokta belirledi: 1... 2... 3..."', isCorrect: true },
        { id: 'C', text: '"Benim fikrim şuydu..."', isCorrect: false },
        { id: 'D', text: 'Diğerlerine bırak', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 MÜKEMMEL! Yapılandırılmış, net ve takım odaklı!',
        wrong: '❌ Grup sunumunda "biz" konuş, "ben" değil!'
      },
      explanation: 'Grup sunumunda: 1) Yapı (1,2,3) 2) "Biz" dili 3) Kısa ve net'
    }
  },

  'CM-M8-U2-L4': {
    lesson_id: 'CM-M8-U2-L4',
    title: '⚡ Sunum Zaman Yarışı',
    type: 'timerace',
    duration: 3,
    xp: 55,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'İdeal sunum süresi?', options: ['10sn', '30-60sn', '3dk', '5dk'], correct: 1 },
        { q: 'Grup sunumunda dil?', options: ['Ben', 'Biz', 'Onlar', 'Sen'], correct: 1 },
        { q: 'Göz teması?', options: ['Tek kişi', 'Herkese', 'Yere', 'Tavana'], correct: 1 },
        { q: 'Doldurma sözcük?', options: ['Yani', 'Birincisi', 'Sonuç', 'Özetle'], correct: 0 },
        { q: 'Sunum başlangıcı?', options: ['Eh, şey...', 'Ana 3 nokta', 'Bilmiyorum', 'Bence...'], correct: 1 },
        { q: 'El nerede?', options: ['Cepte', 'Açık, doğal', 'Arkada', 'Kavuşuk'], correct: 1 }
      ]
    }
  },

  'CM-M8-U2-L5': {
    lesson_id: 'CM-M8-U2-L5',
    title: '🎮 Eşleştir: Sunum',
    type: 'matching',
    duration: 3,
    xp: 40,
    matching: {
      instruction: 'Sunum tekniğini etkisiyle eşleştir',
      pairs: [
        { id: 1, left: 'Dik duruş', right: 'Özgüven gösterir' },
        { id: 2, left: 'Göz taraması', right: 'Herkesi dahil eder' },
        { id: 3, left: 'Yapılandırılmış anlatım', right: 'Anlaşılır kılar' },
        { id: 4, left: '"Biz" dili', right: 'Takım ruhu gösterir' },
        { id: 5, left: 'Kısa tutma', right: 'Dikkat tutar' }
      ]
    }
  },

  // ==================== ÜNİTE 3: GRUP DİNAMİKLERİ ====================
  'CM-M8-U3-L1': {
    lesson_id: 'CM-M8-U3-L1',
    title: 'Grup Rolleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '👥 Grup İçi Roller',
      intro: 'Grup aktivitesinde farklı roller:',
      categories: [
        { icon: '👑', title: 'Lider', examples: 'Yönlendiren', desc: 'DİKKAT: Domine etme!' },
        { icon: '🤝', title: 'Koordinatör', examples: 'Fikirleri birleştiren', desc: 'İDEAL ROL!' },
        { icon: '💡', title: 'Yaratıcı', examples: 'Yeni fikirler sunan', desc: 'Değer katar' },
        { icon: '👥', title: 'Destekci', examples: 'Diğerlerini teşvik eden', desc: 'Takım ruhu' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En güvenli rol?',
        options: [
          { text: 'Baskın lider', isCorrect: false, feedback: '❌ Domine etme riski!' },
          { text: 'Koordinatör', isCorrect: true, feedback: '✅ Dengeli ve etkili!' },
          { text: 'Sessiz gözlemci', isCorrect: false, feedback: '❌ Pasif!' }
        ]
      }
    }
  },

  'CM-M8-U3-L2': {
    lesson_id: 'CM-M8-U3-L2',
    title: 'Sessiz Adayları Dahil Etme',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '👤 Sessiz Adayla İlgilenme',
      intro: 'Sessiz kalanları dahil et = Liderlik göstergesi',
      facts: [
        { icon: '👋', title: 'Söz Ver', text: '"X, sen ne düşünüyorsun?"' },
        { icon: '🙂', title: 'Teşvik Et', text: 'Gülümseyerek davet et' },
        { icon: '👂', title: 'Dinle', text: 'Cevabına dikkatle odaklan' },
        { icon: '✅', title: 'Onayla', text: '"Güzel bir bakış açısı"' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Sessiz adaya?',
        options: [
          { text: 'Kendi işine bak', isCorrect: false, feedback: '❌ Fırsatı kaçırırsın!' },
          { text: 'Nazikçe söz ver, dahil et', isCorrect: true, feedback: '✅ Empati ve liderlik!' },
          { text: 'Değerlendirmeciye söyle', isCorrect: false, feedback: '❌ Ispiyonculuk!' }
        ]
      }
    }
  },

  'CM-M8-U3-L3': {
    lesson_id: 'CM-M8-U3-L3',
    title: 'Baskın Adaylarla Başa Çıkma',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '📢 Baskın Adayla Baş Etme',
      intro: 'Domine eden adaya karşı strateji:',
      steps: [
        { level: 1, title: '👂 DİNLE', desc: 'Bitirmesini bekle' },
        { level: 2, title: '🤝 KABUL ET', desc: '"Güzel bir nokta"' },
        { level: 3, title: '➕ EKLE', desc: '"Buna ek olarak..."' },
        { level: 4, title: '👥 DAĞIT', desc: '"Diğerlerini de dinleyelim"' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Baskın aday söz vermiyorsa?',
        options: [
          { text: 'Sözünü kes', isCorrect: false, feedback: '❌ Kaba!' },
          { text: 'Bekle, fırsat kollarım', isCorrect: false, feedback: '❌ Pasif!' },
          { text: 'Nazikçe "Buna ekleyebilir miyim?"', isCorrect: true, feedback: '✅ Profesyonel!' }
        ]
      }
    }
  },

  'CM-M8-U3-L4': {
    lesson_id: 'CM-M8-U3-L4',
    title: 'Senaryo: Baskın Aday',
    type: 'scenario',
    duration: 5,
    xp: 55,
    scenario: {
      question: '📢 SİMÜLASYON: Domine Eden',
      context: 'Bir aday 3 dakikadır konuşuyor ve kimseye fırsat vermiyor. Değerlendirmeci izliyor.',
      options: [
        { id: 'A', text: 'Sözünü kes, artık benim sıram', isCorrect: false },
        { id: 'B', text: '"Güzel noktalar. Diğer arkadaşların fikirlerini de duyalım?"', isCorrect: true },
        { id: 'C', text: 'Bekle, bitsin', isCorrect: false },
        { id: 'D', text: 'Değerlendirmeciye göz kırp', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 LİDERLİK! Kibarca yönlendirme + Grubu dahil etme = +100 puan!',
        wrong: '❌ Ne kaba ne pasif ol - nazik koordinatör ol!'
      },
      explanation: 'Baskın adaya karşı: 1) Kabul et 2) Nazikçe yönlendir 3) Diğerlerini dahil et'
    }
  },

  'CM-M8-U3-L5': {
    lesson_id: 'CM-M8-U3-L5',
    title: '🎮 Grup Rolleri Eşleştir',
    type: 'matching',
    duration: 3,
    xp: 40,
    matching: {
      instruction: 'Rolü davranışla eşleştir',
      pairs: [
        { id: 1, left: 'Koordinatör', right: 'Fikirleri birleştiren' },
        { id: 2, left: 'Destekci', right: 'Diğerlerini teşvik eden' },
        { id: 3, left: 'Yaratıcı', right: 'Yeni çözümler sunan' },
        { id: 4, left: 'Arabulucu', right: 'Çatışmayı çözen' },
        { id: 5, left: 'Lider', right: 'Yön belirleyen' }
      ]
    }
  },

  // ==================== ÜNİTE 4-6: KISALTILMIŞ ====================
  'CM-M8-U4-L1': {
    lesson_id: 'CM-M8-U4-L1',
    title: 'Fikir Ayrılığı',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🤔 Fikir Ayrılığında Ne Yapmalı?',
      intro: 'Farklı fikirler normal ve değerli!',
      facts: [
        { icon: '👂', title: 'Dinle', text: 'Diğer fikri tam anla' },
        { icon: '✅', title: 'Güçlü Yanı Bul', text: 'Her fikrin iyi noktası' },
        { icon: '🤝', title: 'Köprü Kur', text: '"Senin fikrin + benim fikrim"' },
        { icon: '🎯', title: 'Ortak Çıkar', text: 'Takım hedefine odaklan' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Fikrin kabul görmediğinde?',
        options: [
          { text: 'Israr et, haklısın', isCorrect: false, feedback: '❌ İnatcı!' },
          { text: 'Takım kararına saygı göster', isCorrect: true, feedback: '✅ Olgun ve profesyonel!' },
          { text: 'Kırıl ve çekil', isCorrect: false, feedback: '❌ Dramatik!' }
        ]
      }
    }
  },

  'CM-M8-U5-L1': {
    lesson_id: 'CM-M8-U5-L1',
    title: 'Etkili Konuşma',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🗣️ Etkili Konuşma Kuralları',
      intro: 'Grup içinde nasıl konuşmalı?',
      categories: [
        { icon: '✅', title: 'Kısa', examples: '30-60 saniye', desc: 'Özlü ol' },
        { icon: '✅', title: 'Net', examples: 'Ana fikir + örnek', desc: 'Somut ol' },
        { icon: '❌', title: 'Tekrar', examples: 'Söyleneni tekrarlama', desc: 'Zaman kaybı' },
        { icon: '❌', title: 'Söz Kesme', examples: 'Birinin üzerine atlama', desc: 'Saygısızlık' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Birisi senin fikrini söyledi?',
        options: [
          { text: '"Bu benim fikrimdi!" de', isCorrect: false, feedback: '❌ Ego!' },
          { text: 'O fikri geliştir, farklı açı ekle', isCorrect: true, feedback: '✅ Olgunluk!' },
          { text: 'Sus, artık söyleyecek bir şey yok', isCorrect: false, feedback: '❌ Farklı katkı yap!' }
        ]
      }
    }
  },

  'CM-M8-U6-L1': {
    lesson_id: 'CM-M8-U6-L1',
    title: 'Sorun Çözme Aktivitesi',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🧩 Sorun Çözme Aktiviteleri',
      intro: 'Yaygın grup aktivitesi türleri:',
      facts: [
        { icon: '🧩', title: 'Problem Çözme', text: 'İşbirliğiyle çözüm bul' },
        { icon: '💡', title: 'Yaratıcılık', text: 'Beyin fırtınası' },
        { icon: '🗣️', title: 'Tartışma', text: 'Bir konuda uzlaşma' },
        { icon: '🏗️', title: 'İnşa', text: 'Fiziksel yapı inşası' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Grup aktivitesinde öncelik?',
        options: [
          { text: 'Doğru cevabı bulmak', isCorrect: false, feedback: '❌ Çoğu aktivitede doğru cevap yok!' },
          { text: 'Nasıl işbirliği yaptığın', isCorrect: true, feedback: '✅ SÜRECİ izliyorlar!' },
          { text: 'Lider olmak', isCorrect: false, feedback: '❌ Liderlik tek kriter değil!' }
        ]
      }
    }
  },

  // ==================== ÜNİTE 7: FİNAL ====================
  'CM-M8-U7-L1': {
    lesson_id: 'CM-M8-U7-L1',
    title: 'Tam Simülasyon 1',
    type: 'scenario',
    duration: 8,
    xp: 70,
    scenario: {
      question: '🎯 TAM SİMÜLASYON: Ada Senaryosu',
      context: 'Grubunuz bir adaya düştü. 10 eşyadan sadece 5\'ini alabilirsiniz. Karar vermeniz gerekiyor. Bir aday her şeyi kontrol etmeye çalışıyor.',
      options: [
        { id: 'A', text: 'Baskın adayla rekabet et, kontrolu al', isCorrect: false },
        { id: 'B', text: 'Her eşya için mantıklı tartışma öner, herkesi dahil et', isCorrect: true },
        { id: 'C', text: 'Sessiz kal, baskın aday karar versin', isCorrect: false },
        { id: 'D', text: 'Oylama öner ve kararı bitir', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 MÜKEMMEL! Yapılandırılmış tartışma + Herkesin dahil olması = En iyi yaklaşım!',
        wrong: '❌ Ne rekabet ne pasiflik - koordinasyon ve kapsayıcılık!'
      },
      explanation: 'Grup aktivitesinde SÜREÇ değerlendiriliyor. Doğru cevap değil, nasıl karar verdiğin önemli!'
    }
  },

  // ==================== EKSİK DERSLER ====================
  // ÜNİTE 4: ANLAŞMAZLIK YÖNETİMİ - EKSİKLER
  'CM-M8-U4-L2': {
    lesson_id: 'CM-M8-U4-L2',
    title: 'Uzlaşma Teknikleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🤝 Uzlaşma Sanatı',
      intro: 'Herkesin kabul edebileceği orta yol bulma',
      facts: [
        { icon: '👂', title: 'Dinle', text: 'Her iki tarafı da dinle' },
        { icon: '🔍', title: 'Ortak Nokta', text: 'Hemfikir olunan noktaları bul' },
        { icon: '💡', title: 'Öneri', text: '"Her iki fikri birleştirelim"' },
        { icon: '✅', title: 'Onay', text: '"Herkes için uygun mu?"' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İki kişi farklı fikirde. Ne yaparsınız?',
        options: [
          { text: 'Birini desteklerim', isCorrect: false, feedback: '❌ Taraf tutma!' },
          { text: 'Ortak nokta bulmaya çalışırım', isCorrect: true, feedback: '✅ Arabulucu rolü!' },
          { text: 'Karışmam', isCorrect: false, feedback: '❌ Pasif kalma!' }
        ]
      }
    }
  },

  'CM-M8-U4-L3': {
    lesson_id: 'CM-M8-U4-L3',
    title: 'Senaryo: Anlaşmazlık',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: '⚡ SENARYO: Grup İçi Çatışma',
      context: 'İki aday şiddetli şekilde tartışıyor. Biri "A" diyor, diğeri "B" diyor. Grup kilitlendi.',
      options: [
        { id: 'A', text: '"Her iki fikrin de güçlü yanları var, belki birleştirebiliriz?"', isCorrect: true },
        { id: 'B', text: 'Birinin tarafını tutarım', isCorrect: false },
        { id: 'C', text: 'Sessiz kalırım', isCorrect: false },
        { id: 'D', text: 'Jüriye şikayet ederim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Arabuluculuk ve çözüm odaklılık!',
        wrong: '❌ Taraf tutmak veya sessiz kalmak kötü izlenim bırakır.'
      },
      explanation: 'Arabulucu rolü almak liderlik gösterir ama tarafsız kalın.'
    }
  },

  'CM-M8-U4-L4': {
    lesson_id: 'CM-M8-U4-L4',
    title: '⚡ Uzlaşma Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Çatışmada ilk adım?', options: ['Taraf tut', 'Dinle', 'Konuş', 'Çık'], correct: 1 },
        { q: 'Arabulucu ne yapar?', options: ['Taraf tutar', 'Ortak nokta bulur', 'Susar', 'Şikayet eder'], correct: 1 },
        { q: 'İdeal uzlaşma?', options: ['Biri kazanır', 'İkisi de kazanır', 'İkisi de kaybeder', 'Farketmez'], correct: 1 },
        { q: '"Biz" dili neden iyi?', options: ['Yanlış', 'Takım ruhu', 'Bireysel', 'Farketmez'], correct: 1 },
        { q: 'Fikir reddedilince?', options: ['Kırıl', 'Saygı göster', 'İsrar et', 'Çık'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 5: SÖZLÜ İLETİŞİM - EKSİKLER
  'CM-M8-U5-L2': {
    lesson_id: 'CM-M8-U5-L2',
    title: 'Aktif Dinleme',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '👂 Aktif Dinleme',
      intro: 'Dinlemek = Sadece duymak DEĞİL!',
      facts: [
        { icon: '👀', title: 'Göz Temas', text: 'Konuşana bak' },
        { icon: '📝', title: 'Not Al', text: 'Zihinsel not tut' },
        { icon: '🔄', title: 'Yansıt', text: '"Yani şunu diyorsunuz..."' },
        { icon: '❓', title: 'Soru Sor', text: 'Anlamak için soru sor' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Aktif dinleme göstergesi?',
        options: [
          { text: 'Telefona bakmak', isCorrect: false, feedback: '❌ İlgisizlik!' },
          { text: 'Göz teması ve baş sallama', isCorrect: true, feedback: '✅ İlgi göstergesi!' },
          { text: 'Söz kesmek', isCorrect: false, feedback: '❌ Saygısızlık!' }
        ]
      }
    }
  },

  'CM-M8-U5-L3': {
    lesson_id: 'CM-M8-U5-L3',
    title: 'Fikir Sunumu',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '💡 Fikir Sunma Teknikleri',
      intro: 'Fikrini etkili şekilde sun',
      steps: [
        { level: 1, title: '🎯 Net Ol', desc: 'Kısa ve öz başla' },
        { level: 2, title: '📊 Gerekçele', desc: 'Neden iyi açıkla' },
        { level: 3, title: '🔗 Bağla', desc: 'Önceki fikirlere bağla' },
        { level: 4, title: '❓ Sor', desc: '"Siz ne düşünüyorsunuz?"' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Fikir sunarken ideal süre?',
        options: [
          { text: '5-10 saniye', isCorrect: false, feedback: '❌ Çok kısa!' },
          { text: '30-60 saniye', isCorrect: true, feedback: '✅ Öz ve yeterli!' },
          { text: '5 dakika', isCorrect: false, feedback: '❌ Çok uzun!' }
        ]
      }
    }
  },

  'CM-M8-U5-L4': {
    lesson_id: 'CM-M8-U5-L4',
    title: 'Senaryo: Fikir Sunumu',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: '🎤 SENARYO: Fikrinizi Sunun',
      context: 'Gruba yeni bir fikir sundunuz ama kimse ilgi göstermedi. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Kısaca tekrar açıklar, başkalarının fikrini sorarım', isCorrect: true },
        { id: 'B', text: 'Israr ederim', isCorrect: false },
        { id: 'C', text: 'Küserim', isCorrect: false },
        { id: 'D', text: 'Başka fikir söylerim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Doğru! Kısa tekrar + başkalarını dahil etme!',
        wrong: '❌ Israr etmek veya küsmek profesyonel değil.'
      },
      explanation: '"Belki iyi anlatamadım, şunu demek istiyorum..." gibi.'
    }
  },

  'CM-M8-U5-L5': {
    lesson_id: 'CM-M8-U5-L5',
    title: '🎮 Boşluk Doldur: İletişim',
    type: 'fillin',
    duration: 4,
    xp: 35,
    fillin: {
      sentences: [
        { text: 'Aktif dinlemede ___ teması önemlidir.', answer: 'göz' },
        { text: 'Fikir sunarken ___ ve öz olun.', answer: 'kısa' },
        { text: 'Grup sunumunda "ben" yerine "___" deyin.', answer: 'biz' },
        { text: 'Konuşma süresi ___-60 saniye olmalı.', answer: '30' },
        { text: 'Başkalarının fikrini ___ gösterin.', answer: 'saygı' }
      ]
    }
  },

  // ÜNİTE 6: AKTİVİTE TİPLERİ - EKSİKLER
  'CM-M8-U6-L2': {
    lesson_id: 'CM-M8-U6-L2',
    title: 'Yaratıcılık Aktivitesi',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🎨 Yaratıcılık Görevleri',
      intro: 'Havayolları yaratıcı düşünce arar',
      facts: [
        { icon: '💡', title: 'Beyin Fırtınası', text: 'Yargılamadan fikir üret' },
        { icon: '🔗', title: 'Birleştir', text: 'Fikirleri kombine et' },
        { icon: '🎯', title: 'Seç', text: 'En iyisini demokratik seç' },
        { icon: '🎤', title: 'Sun', text: 'Takım olarak sun' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Yaratıcılık aktivitesinde önemli olan?',
        options: [
          { text: 'En çılgın fikir', isCorrect: false, feedback: '❌ Uygulanabilir olmalı!' },
          { text: 'Takım çalışması ve süreç', isCorrect: true, feedback: '✅ Sonuç değil, süreç!' },
          { text: 'Tek başına çözmek', isCorrect: false, feedback: '❌ Takım aktivitesi!' }
        ]
      }
    }
  },

  'CM-M8-U6-L3': {
    lesson_id: 'CM-M8-U6-L3',
    title: 'Tartışma Aktivitesi',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '💬 Tartışma Görevleri',
      intro: 'Belirli bir konu hakkında grup tartışması',
      categories: [
        { icon: '✅', title: 'Doğru', examples: 'Herkesin fikrini al', desc: 'Kapsayıcı ol' },
        { icon: '✅', title: 'Doğru', examples: 'Farklı görüşleri kabul et', desc: 'Açık fikirli' },
        { icon: '❌', title: 'Yanlış', examples: 'Tek bir görüşe takılma', desc: 'Israr etme' },
        { icon: '❌', title: 'Yanlış', examples: 'Başkalarını susturma', desc: 'Baskın olma' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Tartışmada ideal yaklaşım?',
        options: [
          { text: 'Kendi fikrini savun', isCorrect: false, feedback: '❌ Tek taraflı!' },
          { text: 'Herkesi dahil et, ortak karar al', isCorrect: true, feedback: '✅ Demokratik!' },
          { text: 'Sessiz kal', isCorrect: false, feedback: '❌ Katkısız!' }
        ]
      }
    }
  },

  'CM-M8-U6-L4': {
    lesson_id: 'CM-M8-U6-L4',
    title: 'Senaryo: Yaratıcılık',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: '🎨 SENARYO: Yaratıcı Görev',
      context: 'Grubunuza "Yeni bir havayolu maskotu tasarlayın" görevi verildi. 10 dakikanız var.',
      options: [
        { id: 'A', text: 'Herkesin fikrini alır, en iyilerini birleştirir, demokratik karar alırım', isCorrect: true },
        { id: 'B', text: 'Kendi fikrimi dayatırım', isCorrect: false },
        { id: 'C', text: 'Başkalarının yapmasını beklerim', isCorrect: false },
        { id: 'D', text: 'En sessiz olanın fikrini seçerim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Kapsayıcı ve demokratik!',
        wrong: '❌ Baskın olmak veya pasif kalmak değerlendirilmez.'
      },
      explanation: 'Yaratıcılık = Takım çalışması + Herkesin katkısı'
    }
  },

  'CM-M8-U6-L5': {
    lesson_id: 'CM-M8-U6-L5',
    title: '⚡ Aktivite Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 50,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'Grup aktivitesinde önemli olan?', options: ['Sonuç', 'Süreç', 'Hız', 'Cevap'], correct: 1 },
        { q: 'Yaratıcılıkta ilk adım?', options: ['Eleştir', 'Beyin fırtınası', 'Seç', 'Bitir'], correct: 1 },
        { q: 'Tartışmada taraf tutmak?', options: ['İyi', 'Kötü', 'Normal', 'Gerekli'], correct: 1 },
        { q: 'Demokratik karar nedir?', options: ['Lider seçer', 'Herkes kabul eder', 'Oylama yok', 'Tek kişi'], correct: 1 },
        { q: 'Aktivite sonunda?', options: ['Tek sun', 'Takım sun', 'Kimse sunmaz', 'Jüri sunar'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 7: FİNAL SİMÜLASYONLAR - EKSİKLER
  'CM-M8-U7-L2': {
    lesson_id: 'CM-M8-U7-L2',
    title: 'Tam Simülasyon 2',
    type: 'scenario',
    duration: 15,
    xp: 60,
    scenario: {
      question: '🎭 SİMÜLASYON 2: Acil Durum Tartışması',
      context: 'Grubunuza soru: "Uçakta kalp krizi geçiren bir yolcu var. Hekim yok. Ne yaparsınız?" Tartışın ve karar verin.',
      options: [
        { id: 'A', text: 'Fikirlerimi söyler, herkesi dinler, ortak çözüm üretirim', isCorrect: true },
        { id: 'B', text: 'Hemen cevap veririm, tartışmaya gerek yok', isCorrect: false },
        { id: 'C', text: 'Bilmiyorum deyip susarım', isCorrect: false },
        { id: 'D', text: 'En çok konuşan kişiyi desteklerim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Harika! Katılım + Dinleme + Çözüm = İdeal aday!',
        wrong: '❌ Grup tartışması = Herkesin katkısı + Ortak karar'
      },
      explanation: 'Doğru cevap: CPR, AED kullanımı, anons ile doktor arama. Ama önemli olan SÜREÇ!'
    }
  },

  'CM-M8-U7-L3': {
    lesson_id: 'CM-M8-U7-L3',
    title: 'Tam Simülasyon 3',
    type: 'scenario',
    duration: 15,
    xp: 60,
    scenario: {
      question: '🎭 SİMÜLASYON 3: Etik İkilem',
      context: 'Soru: "VIP yolcu kabin kurallarını ihlal ediyor. Ne yaparsınız?" Grup olarak tartışın.',
      options: [
        { id: 'A', text: 'Kuralların herkes için geçerli olduğunu, nazik ama kararlı yaklaşım gerektiğini savunurum', isCorrect: true },
        { id: 'B', text: 'VIP olduğu için görmezden gelmek lazım', isCorrect: false },
        { id: 'C', text: 'Hemen güvenliği çağırmak lazım', isCorrect: false },
        { id: 'D', text: 'Bu soruyu geçelim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Doğru! Kurallar herkes için, ama profesyonel yaklaşım şart.',
        wrong: '❌ Ayrımcılık veya aşırı tepki uygun değil. Profesyonel denge!'
      },
      explanation: 'Nazik uyarı → Kuralları hatırlat → Gerekirse üst bilgilendir'
    }
  },

  'CM-M8-U7-L4': {
    lesson_id: 'CM-M8-U7-L4',
    title: '🎓 Grup Mülakatı Final Quiz',
    type: 'exam',
    duration: 10,
    xp: 100,
    exam: {
      questions: [
        { q: 'En güvenli grup rolü?', options: ['Lider', 'Koordinatör', 'Sessiz', 'Muhalif'], correct: 1 },
        { q: 'Baskın adaya karşı?', options: ['Kavga', 'Nazik yönlendirme', 'Susma', 'Kaytarma'], correct: 1 },
        { q: 'Sessiz adaya?', options: ['Umursama', 'Söz ver', 'Şikayet', 'Alay'], correct: 1 },
        { q: 'İdeal konuşma süresi?', options: ['10sn', '30-60sn', '3dk', '10dk'], correct: 1 },
        { q: 'Grup sunumunda dil?', options: ['Ben', 'Biz', 'Onlar', 'Sen'], correct: 1 },
        { q: 'Fikir çatışmasında?', options: ['Taraf tut', 'Arabulucu ol', 'Karışma', 'Tartış'], correct: 1 },
        { q: 'Değerlendirmeciler ne izler?', options: ['Sonuç', 'Süreç', 'Konuşma', 'Görünüm'], correct: 1 },
        { q: 'Söz kesmek?', options: ['Normal', 'Saygısızlık', 'Liderlik', 'Gerekli'], correct: 1 },
        { q: 'Fikrin kabul görmeyince?', options: ['Israr', 'Saygı göster', 'Kırıl', 'Çık'], correct: 1 },
        { q: 'Grup başarısı?', options: ['Tek kişi', 'Herkesin', 'Önemsiz', 'Lider\'in'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM8Interactive;
